import React from 'react';
import Button from 'components/control/button';
import styles from './style.module.scss';
import { buildClassName } from 'utils/build-class-name';
import { blurIds } from 'constants/test-constants';
import { useTranslation } from 'next-i18next';
import { LOCALE_COMMON_PATHS, Namespaces } from 'types/locales';

interface Props {
  isLoginRequired: boolean;
  isTermsRequired?: boolean;
  isSmallCard?: boolean;
  isExpHomeTheme?: boolean;
  isCrea: boolean;
}

export default function ListingCardNewOverlay({ isLoginRequired, isTermsRequired, isSmallCard = false, isCrea, isExpHomeTheme = false }: Props) {
  const { t } = useTranslation(Namespaces.COMMON);

  if (isLoginRequired && !isCrea) {
    return (
      <div className={buildClassName(styles.component, !isSmallCard ? styles['component-regular'] : styles['component-small'])}>
        <p className={styles.disclaimer} data-testid={blurIds.overlaySignInMsg}>
          {t(LOCALE_COMMON_PATHS.LISTING_CARD_COMPLIANCE_OVERLAY_SIGN_IN_MESSAGE, {
            defaultValue: 'Real estate boards require that you sign in to see listing details',
          })}
        </p>
        <Button
          theme="secondary"
          expHomePadding={isExpHomeTheme}
          className={styles['cta-button']}
          testId={blurIds.overlaySignInBtn}
          label={t(LOCALE_COMMON_PATHS.BUTTON_SIGN_IN, { defaultValue: 'Sign In' })}
        />
      </div>
    );
  } else if (isTermsRequired) {
    return (
      <div className={buildClassName(styles.component, !isSmallCard ? styles['component-regular'] : styles['component-small'])}>
        <p className={styles.disclaimer} data-testid={blurIds.overlaySignInMsg}>
          {t(LOCALE_COMMON_PATHS.LISTING_CARD_COMPLIANCE_OVERLAY_TERMS_OF_USE_MESSAGE, {
            defaultValue: 'Accept Terms of Use to see listing details',
          })}
        </p>
        <Button
          theme="secondary"
          className={styles['cta-button']}
          testId={blurIds.overlaySignInBtn}
          label={t(LOCALE_COMMON_PATHS.BUTTON_VIEW, { defaultValue: 'View' })}
        />
      </div>
    );
  } else {
    return null;
  }
}
